import {PredictionWidgetCardsModel} from "./prediction-widget.cards.model";
import {override} from "mobx";
import {PredictionDetailsPopup} from "../../../../core/components/prediction/models/assets/prediction-details-popup";

export class PredictionWidgetPropsCardsModel extends PredictionWidgetCardsModel {
  @override get isPlayerBet(): Boolean {
    return true;
  }

  @override get hasIcon(): Boolean {
    return true;
  }

  @override get iconSource(): Boolean {
    return new PredictionDetailsPopup(16,16);
  }
}
